"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getFullName = function (person, pronounsEnabled) {
    var _a, _b;
    var firstName = ((person === null || person === void 0 ? void 0 : person.preferredName) || (person === null || person === void 0 ? void 0 : person.firstName) || '').trim();
    var lastName = ((person === null || person === void 0 ? void 0 : person.lastName) || '').trim();
    var fullName = "".concat(firstName, " ").concat(lastName);
    fullName = fullName.trim();
    return "".concat(fullName).concat(((_a = person === null || person === void 0 ? void 0 : person.profile) === null || _a === void 0 ? void 0 : _a.pronoun) && pronounsEnabled
        ? " (".concat((_b = person === null || person === void 0 ? void 0 : person.profile) === null || _b === void 0 ? void 0 : _b.pronoun, ")")
        : '');
};
exports.default = getFullName;
//# sourceMappingURL=getFullName.js.map